import React, { FC } from 'react';
import { ScaleFunction, WrapperOverColorFunction } from '@components/operatorPanel/interfaces';
import OperatorPanelNoConnector from './elements/OperatorPanelNoConnector';
import OperatorPanelConnectorOffline from './elements/OperatorPanelConnectorOffline';
import OperatorPanelConnectorLoading from './elements/OperatorPanelConnectorLoading';
import OperatorPanelMachineOffline from './elements/OperatorPanelMachineOffline';
import OperatorPanelNotProductive from './elements/OperatorPanelNotProductive';
import OperatorPanelConnectionOff from './elements/OperatorPanelConnectionOff';
import { scale as initialScale } from '@components/frame';
import { font as initialFont } from '@styles/fonts';

interface UnavailableContentComponentsProps {
  CC: WrapperOverColorFunction;
  machineName: string;
  machineStatus: string;
  noConnector: boolean;
  connectorOffline: boolean;
  connectorLoading: boolean;
  machineOffline: boolean;
  notProductive: boolean;
  lastUpdatedOn: string;
  lastAliveEventReceivedOn?: string;
  subStatus: string;
  isOperator?: boolean;
  connectionSwitchedOff: boolean;
  insetTop: number;
  insetBottom: number;
  scale?: ScaleFunction;
  font?: typeof initialFont;
}

const UnavailableContentComponents: FC<UnavailableContentComponentsProps> = ({
  CC,
  connectorLoading,
  connectorOffline,
  connectionSwitchedOff,
  lastAliveEventReceivedOn,
  lastUpdatedOn,
  machineName,
  machineOffline,
  machineStatus,
  noConnector,
  notProductive,
  subStatus,
  insetTop,
  insetBottom,
  scale = initialScale,
  font = initialFont,
  isOperator = true,
}) => {
  const unavailableContentProps = {
    CC,
    machineName,
    isOperator,
    machineStatus,
    insetTop,
    insetBottom,
    scale,
    font,
  };

  if (noConnector) {
    return <OperatorPanelNoConnector {...unavailableContentProps} time={lastAliveEventReceivedOn} />;
  }

  if (connectorOffline) {
    return <OperatorPanelConnectorOffline {...unavailableContentProps} time={lastAliveEventReceivedOn} />;
  }

  if (connectionSwitchedOff) {
    return <OperatorPanelConnectionOff {...unavailableContentProps} time={lastAliveEventReceivedOn} />;
  }

  if (connectorLoading) {
    return <OperatorPanelConnectorLoading {...unavailableContentProps} />;
  }

  if (machineOffline) {
    return <OperatorPanelMachineOffline {...unavailableContentProps} machineSubStatus={subStatus} time={lastUpdatedOn} />;
  }

  if (notProductive) {
    return <OperatorPanelNotProductive {...unavailableContentProps} time={lastUpdatedOn} />;
  }

  return null;
};

export { UnavailableContentComponents };
